import { axiosInstance } from '../../axios';
import {
  CreateToolPresetPayload,
  ToolPreset,
  UpdateToolPresetPayload,
} from './tool-preset.interface';

export function fetchToolPresets() {
  return axiosInstance
    .get<ToolPreset[]>('/api/admin/tool-preset')
    .then((response) => response.data);
}

export function fetchToolPreset(id: string) {
  return axiosInstance
    .get<ToolPreset>(`/api/admin/tool-preset/${id}`)
    .then((response) => response.data);
}

export function createToolPreset(payload: CreateToolPresetPayload) {
  return axiosInstance
    .post<ToolPreset>('/api/admin/tool-preset', payload)
    .then((response) => response.data);
}

export function updateToolPreset(id: string, payload: UpdateToolPresetPayload) {
  return axiosInstance
    .patch<ToolPreset>(`/api/admin/tool-preset/${id}`, payload)
    .then((response) => response.data);
}

export function deleteToolPreset(id: string) {
  return axiosInstance
    .delete<ToolPreset>(`/api/admin/tool-preset/${id}`)
    .then((response) => response.data);
}
